import { render, staticRenderFns } from "./AuditDetails.template.vue?vue&type=template&id=0c88ed45&scoped=true&"
var script = {}
import style0 from "./AuditDetails.template.vue?vue&type=style&index=0&id=0c88ed45&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88ed45",
  null
  
)

export default component.exports